import { Injectable } from '@angular/core';
import { PopupRef, PopupService, PopupSettings } from '@progress/kendo-angular-popup';
import { BehaviorSubject } from 'rxjs';
import { ShiveRenderService } from '../rendering/shive-render.service';

@Injectable({
  providedIn: 'root',
})
export class ShivePopupService {
  public dataLoaded$ = new BehaviorSubject<any>(null);
  public popupRef: PopupRef;
  public anchor: HTMLElement;

  private readonly defaultContextMenuSettings: PopupSettings = {
    popupAlign: {
      horizontal: 'right',
      vertical: 'center',
    },
    anchorAlign: {
      horizontal: 'right',
      vertical: 'center',
    },
    margin: {
      horizontal: 40,
      vertical: 0,
    },
    popupClass: 'grid-context-menu context-menu',
    animate: false,
  };

  constructor(
    private readonly popupService: PopupService,
    private readonly renderer: ShiveRenderService,
  ) {}

  public open(popupSettings: PopupSettings): PopupRef {
    const updatedSettings: PopupSettings = {
      ...this.defaultContextMenuSettings,
      ...popupSettings,
    };

    this.anchor = updatedSettings.anchor as HTMLElement;
    this.popupRef = this.popupService.open(updatedSettings);

    const container = this.popupRef.popupElement;
    this.renderer.addClass(container, 'k-overflow-visible');

    return this.popupRef;
  }

  public close(): void {
    this.popupRef.close();
    this.popupRef = null;
    this.anchor = null;
  }

  public contains(target: Node): boolean {
    return (
      this.anchor?.contains(target) ||
      (this.popupRef?.popup
        ? this.popupRef.popup.instance.container.nativeElement.contains(target)
        : false)
    );
  }
}
